"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('viewModels/fourFive/fourFivePolicyViewModel',["require", "exports", "knockout", "moment"], function (require, exports, ko, moment) {
    "use strict";

    var FourFivePolicyViewModel = function () {
        function FourFivePolicyViewModel(fourFivePolicy) {
            _classCallCheck(this, FourFivePolicyViewModel);

            this.brokerPolicyId = ko.observable('');
            this.coverStartDate = ko.observable('');
            this.coverEndDate = ko.observable('');
            this.coverCancelledDate = ko.observable('');
            this.scheme = ko.observable('');
            this.insurer = ko.observable('');
            this.brokerBranchId = ko.observable('');
            this.broker = ko.observable('');
            this.forename = ko.observable('');
            this.surname = ko.observable('');
            this.title = ko.observable('');
            this.gender = ko.observable('');
            this.dateOfBirth = ko.observable('');
            this.mobileNumber = ko.observable('');
            this.email = ko.observable('');
            this.postcode = ko.observable('');
            this.vehicleRegistration = ko.observable('');
            this.fullName = ko.pureComputed(this.computeFullName, this);
            this.update(fourFivePolicy);
        }

        _createClass(FourFivePolicyViewModel, [{
            key: "update",
            value: function update(fourFivePolicy) {
                this.brokerPolicyId(fourFivePolicy.brokerPolicyId);
                this.coverStartDate(moment(fourFivePolicy.coverStartDate).format('DD/MM/YYYY HH:mm:ss'));
                this.coverEndDate(moment(fourFivePolicy.coverEndDate).format('DD/MM/YYYY HH:mm:ss'));
                this.coverCancelledDate(fourFivePolicy.coverCancelledDate ? moment(fourFivePolicy.coverCancelledDate).format('DD/MM/YYYY HH:mm:ss') : '');
                this.scheme(fourFivePolicy.scheme);
                this.insurer(fourFivePolicy.insurer);
                this.brokerBranchId(fourFivePolicy.brokerBranchId);
                this.broker(fourFivePolicy.broker);
                this.forename(fourFivePolicy.forename);
                this.surname(fourFivePolicy.surname);
                this.title(fourFivePolicy.title);
                this.gender(fourFivePolicy.gender === 1 ? 'Male' : 'Female');
                this.dateOfBirth(moment(fourFivePolicy.dateOfBirth).format('DD/MM/YYYY HH:mm:ss'));
                this.mobileNumber(fourFivePolicy.mobileNumber);
                this.email(fourFivePolicy.email);
                this.postcode(fourFivePolicy.postcode);
                this.vehicleRegistration(fourFivePolicy.vehicleRegistration);
            }
        }, {
            key: "computeFullName",
            value: function computeFullName() {
                var fullName = '';
                if (this.title()) {
                    fullName += this.title() + ' ';
                }
                if (this.forename()) {
                    fullName += this.forename() + ' ';
                }
                if (this.surname()) {
                    fullName += this.surname() + ' ';
                }
                return fullName;
            }
        }, {
            key: "clear",
            value: function clear() {
                this.brokerPolicyId('');
                this.coverStartDate('');
                this.coverEndDate('');
                this.coverCancelledDate('');
                this.scheme('');
                this.insurer('');
                this.brokerBranchId('');
                this.broker('');
                this.forename('');
                this.surname('');
                this.title('');
                this.gender('');
                this.dateOfBirth('');
                this.mobileNumber('');
                this.email('');
                this.postcode('');
                this.vehicleRegistration('');
            }
        }]);

        return FourFivePolicyViewModel;
    }();

    return FourFivePolicyViewModel;
});
//# sourceMappingURL=fourFivePolicyViewModel.js.map;
